import { useParams } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Spinner } from '@/components/ui/spinner';
import { useProject } from '@/lib/api';
import { PermissionGrid } from '@/components/projects/PermissionGrid';

export function ProjectMembersTab() {
  const { wsId = '', projId = '' } = useParams<{ wsId: string; projId: string }>();
  const project = useProject(projId);

  if (project.isLoading) return <Spinner label="Loading…" />;
  if (!project.data) return null;

  const languages: string[] = [
    project.data.sourceLanguageCode,
    ...(project.data.targetLanguageCodes ?? []),
  ];

  return (
    <Card>
      <CardHeader>
        <CardTitle>Per-language permissions</CardTitle>
        <CardDescription>
          Workspace owners and admins always have full project access. Translators get
          per-language read/write grants here.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <PermissionGrid workspaceID={wsId} projectID={projId} languages={languages} />
      </CardContent>
    </Card>
  );
}
